import { FeatureFlagInterceptorModule } from '@app/modules/feature-flag/featureFlagInterceptor.module';
import { common } from './common';
import { EnvironmentSettings } from './environment-interface';

export const environment: EnvironmentSettings = {
    ...common,
    envModules: [FeatureFlagInterceptorModule],
    production: true,
    name: 'demo',
    url: 'https://demo-hr.humi.ca',
    api: 'https://demo-api.humi.ca',
    payrollUrl: 'https://demo.payroll.humi.ca',
    stripeKey: 'pk_test_ifjlT2peLVylXoYuSzIbLGSI',
    sentry: 'https://f160c28cf8b14d3b8fe72424f852e601@sentry.io/302995',
    launchDarkly: '5db2eed20d9d6808b67ce528',
    helloSignClientId: '9a6563a52a0ab42ea4547382fc7e7acd',
    pusher: {
        id: 493726,
        key: '2706899cafdd6c785e09',
        cluster: 'us2',
    },
    enableBeamer: true,
    jobBoardDomain: 'applytojob.link',
    googleMapsApiKey: 'AIzaSyCAp3GjlzoLRngAFXCkELIPLgYwTuykapU',
    simplyBenefitsAdminPanelUrl: 'https://app-staging.simplybenefits.ca/admin/login',
    simplyBenefitsEmployeePortalUrl: 'https://member-staging.simplybenefits.ca/login',
    auth0: {
        domain: 'demo-account.humi.ca',
        clientId: 'gzt2fP6fY2hbK9NINSfNkNUf8JxOoTmd',
        authorizationParams: {
            audience: 'https://demo-api.humi.ca',
            redirect_uri: 'https://demo-hr.humi.ca/auth0callback',
        },
    },
    chiliPiper: {
        subdomain: 'humi-ca',
        router: 'implementation_router',
    },
};
